import { render } from "./ResetPasswordPage.vue?vue&type=template&id=63f4f136&scoped=true&ts=true"
import script from "./ResetPasswordPage.vue?vue&type=script&lang=ts"
export * from "./ResetPasswordPage.vue?vue&type=script&lang=ts"

import "./ResetPasswordPage.vue?vue&type=style&index=0&id=63f4f136&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63f4f136"]])

export default __exports__